/* eslint-disable react/prop-types */
import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import invoicemanagement from '../../../Assets/AlertIcon/invoicemanagement.svg';
import invoicemanagementbg from '../../../Assets/AlertIcon/invoicemanagementBg.svg';

export const SystemAdminInvoiceManagementModules = ({ permissionNames, handleNavigation }) => {
  const [expanded, setExpanded] = useState(false);

  const hasAccess = permissionNames?.includes('System Invoice Management');
  if (!hasAccess) {
    return null;
  }

  const items = [
    { key: 'System Purchase Order Management', displayName: 'Purchase Order Management' },
    { key: 'System PO Workflow Management', displayName: 'Vendor Invoice Management' },
  ];

  return (
    <>
      <Box
        sx={{
          width: '100%',
          height: '100%',
          mt: '3%',
          p: '14px 16px',
          bgcolor: '#f8e8e9',
          boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.08)',
          borderRadius: '16px',
          display: 'inline-flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          gap: '10px',
          cursor: 'pointer',
          transition: 'all 0.3s cubic-bezier(.25,.8,.25,1)',
          '&:hover': {
            boxShadow: '0 8px 32px 0 rgba(61, 0, 102, 0.25), 0 1.5px 8px 0 rgba(0,0,0,0.10)',
            transform: 'scale(1.04) translateY(-2px)',
            bgcolor: 'linear-gradient(90deg, #f8fafc 0%, #e0e7ff 100%)',
            border: '1.5px solid rgb(185, 168, 212)',
            '& .MuiTypography-root': {
              background: 'linear-gradient(90deg, #a18cd1 0%,rgb(119, 190, 191) 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              color: 'transparent',
            },
          },
        }}
        onClick={() => setExpanded(!expanded)}
      >
        <Box
          sx={{
            width: '100%',
            display: 'inline-flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <img src={invoicemanagement} />
            <Typography
              sx={{
                fontSize: '16px',
                fontFamily: 'Inter',
                fontWeight: 500,
                color: '#181818',
                wordWrap: 'break-word',
              }}
            >
              System Invoice Management
            </Typography>
          </Box>
          <Box
            sx={{
              transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s ease',
              fontSize: '20px',
              color: '#ce989c',
            }}
          >
            ▼
          </Box>
        </Box>
      </Box>

      {expanded && (
        <Box
          sx={{
            width: '95%',
            mt: '2%',
            ml: '20px',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            animation: 'slideDown 0.3s ease-out',
            '@keyframes slideDown': {
              '0%': { opacity: 0, transform: 'translateY(-10px)' },
              '100%': { opacity: 1, transform: 'translateY(0)' },
            },
          }}
        >
          {items.map((item) => (
            <Box
              key={item.key}
              sx={{
                width: '100%',
                height: '100%',
                p: '14px 16px',
                bgcolor: '#f8e8e9',
                boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.08)',
                borderRadius: '16px',
                display: 'inline-flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                gap: '10px',
                cursor: 'pointer',
                transition: 'all 0.3s cubic-bezier(.25,.8,.25,1)',
                '&:hover': {
                  boxShadow: '0 8px 32px 0 rgba(61, 0, 102, 0.25), 0 1.5px 8px 0 rgba(0,0,0,0.10)',
                  transform: 'scale(1.04) translateY(-2px)',
                  bgcolor: 'linear-gradient(90deg, #f8fafc 0%, #e0e7ff 100%)',
                  border: '1.5px solid rgb(185, 168, 212)',
                  '& .MuiTypography-root': {
                    background: 'linear-gradient(90deg, #a18cd1 0%,rgb(119, 190, 191) 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                    color: 'transparent',
                  },
                },
              }}
              onClick={() => handleNavigation(item.key)}
            >
              <Box
                sx={{
                  width: '100%',
                  display: 'inline-flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                  <img src={invoicemanagementbg} />
                  <Typography
                    sx={{
                      fontSize: '16px',
                      fontFamily: 'Inter',
                      fontWeight: 500,
                      color: '#181818',
                      wordWrap: 'break-word',
                    }}
                  >
                    {item.displayName}
                  </Typography>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </>
  );
};
